<template>
  <div>
    <b-row>
      <b-col
        v-for="item in prestacoescontas"
        :key="item.id"
        cols="12"
        md="4"
        class="d-flex"
      >
        <prestacao-card
          :item="item"
          @cardClick="visualizarItem"
        />
      </b-col>
    </b-row>
    <infinite-loading @infinite="infiniteHandler">
      <div slot="no-more">
        Já carregamos todas as prestações =)
      </div>
      <no-content-prestacao-conta slot="no-results" />
      <div slot="spinner">
        Carregando...
      </div>
    </infinite-loading>
  </div>
</template>
<script>
import InfiniteLoading from 'vue-infinite-loading'
import NoContentPrestacaoConta from './NoContentPrestacaoConta.vue'
import PrestacaoCard from './PrestacaoCard.vue'

export default {
  components: {
    PrestacaoCard,
    InfiniteLoading,
    NoContentPrestacaoConta,
  },
  data() {
    return {
      pagination: { page: 1, size: 10 },
    }
  },
  computed: {
    prestacoescontas() {
      return this.$store.state.prestacaocontas.prestacoescontas
    },
  },
  beforeCreate() {
    this.$store.dispatch('prestacaocontas/clear')
  },
  methods: {
    infiniteHandler($state) {
      this.$store
        .dispatch('prestacaocontas/fetchAll', { pagina: this.pagination.page })
        .then(res => {
          if (res.data && res.data.length > 0) {
            this.pagination.page += 1
            $state.loaded()
          } else {
            $state.complete()
          }
        })
        .catch(() => $state.complete())
    },
    visualizarItem(id) {
      this.$router.push(`/prestacaocontas/view/${id}`).catch(() => {})
    },
  },
}
</script>
